"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = require("./utils/assert");
var redirect_1 = require("./utils/redirect");
var serialize_1 = require("./utils/serialize");
var codeVerifier_1 = require("./utils/codeVerifier");
exports.login = function (options) {
    assert_1.assert(options, ['client_id', 'url', 'redirect_url']);
    var params = {
        client_id: options.client_id,
        gateway: options.gateway,
        login_theme: options.theme,
        redirect_uri: options.redirect_url,
        response_type: 'token',
        scope: options.scope,
        state: options.state,
    };
    var url = options.url + "/oauth/authorize?" + serialize_1.stringify(params);
    var fn = options.onLoginRedirect || redirect_1.redirect;
    return fn(url);
};
exports.loginWithPKCE = function (options) {
    assert_1.assert(options, ['client_id', 'url', 'redirect_url', 'code_verifier']);
    var params = {
        client_id: options.client_id,
        gateway: options.gateway,
        login_theme: options.theme,
        redirect_uri: options.redirect_url,
        response_type: 'code',
        code_challenge: '',
        code_challenge_method: 'S256',
        scope: options.scope,
        state: options.state,
    };
    return codeVerifier_1.getBase64UrlEncodedCodeVerifier(options.code_verifier).then(function (challenge) {
        if (!challenge) {
            throw new Error('Code challenge is required');
        }
        params.code_challenge = challenge;
        var url = options.url + "/oauth/authorize?" + serialize_1.stringify(params);
        var fn = options.onLoginRedirect || redirect_1.redirect;
        return fn(url);
    });
};
exports.loginWithSSO = function (options) { return exports.login(__assign(__assign({}, options), { gateway: true })); };
//# sourceMappingURL=login.js.map